import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/store'

import ElementUI from 'element-ui';

import locale from 'element-ui/lib/locale/lang/en'
Vue.use(ElementUI, { locale });

import _ from 'lodash';
Object.defineProperty(Vue.prototype, '$_', { value: _ });


import VeeValidate from 'vee-validate';
Vue.use(VeeValidate, {
	events: "blur"
});

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount(window.sunstonevNext.apps.account.data.appId);


